{
  "name": "collabor8",
  "version": "1.1.83",
  "description": "collabor8",
  "private": true,
  "engines": {
    "node": "24",
    "npm": "11"
  },
  "scripts": {
    "set-env": "ts-node set-env.ts",
    "start": "node backend/dist/index.js",
    "test": "cd backend && npm run test",
    "batch": "cd backend && npm run batch",
    "backend:watch": "cd backend && npm run dev:watch",
    "build": "cd backend && tsc && cd .. && ng build",
    "sdk": "cd backend && npm run sdk",
    "sdk:watch": "cd backend && npm run sdk:watch ",
    "angular:watch": "ng build --watch",
    "angular:serve": "ng serve --host=0.0.0.0 --port 4200 --proxy-config proxy.config.json",
    "dev:watch": "concurrently --names \"Angular,Backend,SDK\" -c \"bgGreen.bold,bgBlue.bold,bgMagenta.bold\" \"npm run angular:watch\" \"npm run backend:watch\" \"npm run sdk:watch\"",
    "postinstall": "cd backend && npm i",
    "release": "generate-release"
  },
  "config": {
    "generateRelease": {
      "files_to_version": [
        "azure-pipelines.yml",
        "backend/package.json",
        "backend/package-lock.json",
        "package-lock.json"
      ]
    }
  },
  "overrides": {
    "esbuild": "^0.28.1",
    "uuid": "^11.1.1",
    "shell-quote": "^1.8.4",
    "webpack-dev-server": "^5.2.4"
  },
  "dependencies": {
    "@angular-devkit/build-angular": "^21.1.3",
    "@angular/animations": "^21.1.3",
    "@angular/cli": "^21.1.3",
    "@angular/common": "^21.1.3",
    "@angular/compiler": "^21.1.3",
    "@angular/compiler-cli": "^21.1.3",
    "@angular/core": "^21.1.3",
    "@angular/forms": "^21.1.3",
    "@angular/localize": "^21.1.3",
    "@angular/platform-browser": "^21.1.3",
    "@angular/platform-browser-dynamic": "^21.1.3",
    "@angular/router": "^21.1.3",
    "@azure/storage-blob": "^12.8.0",
    "@babel/helper-string-parser": "^7.25.9",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@openapitools/openapi-generator-cli": "^2.4.1",
    "@popperjs/core": "2.11.8",
    "bootstrap": "5.3.8",
    "colors": "^1.1.2",
    "moment": "^2.30.1",
    "ngx-embedded-media": "^10.1.3",
    "ngx-mask": "^21.0.0",
    "ngx-pull-to-refresh": "^20.0.0",
    "rxjs": "^7.8.1",
    "stacktrace-gps": "^3.0.4",
    "stacktrace-js": "^2.0.2",
    "tslib": "^2.3.1",
    "typescript": "~5.9.3",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "21.0.0",
    "@angular-eslint/eslint-plugin": "21.0.0",
    "@angular-eslint/eslint-plugin-template": "21.0.0",
    "@angular-eslint/schematics": "^21.0.0",
    "@angular-eslint/template-parser": "21.0.0",
    "@types/lodash": "^4.14.181",
    "@types/node": "^12.20.47",
    "@typescript-eslint/eslint-plugin": "^7.18.0",
    "@typescript-eslint/parser": "^7.18.0",
    "app-root-path": "^3.0.0",
    "codelyzer": "^6.0.0",
    "concurrently": "^5.3.0",
    "dotenv": "^8.2.0",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-imengine": "file:eslint",
    "eslint-plugin-prettier": "^5.2.1",
    "express-openapi-validate": "^0.5.1",
    "generate-release": "^1.1.1",
    "js-yaml": "^3.14.0",
    "nodemon": "^2.0.20",
    "prettier": "^3.3.3",
    "ts-node": "~5.0.1",
    "tslint": "~6.1.0",
    "webpack-bundle-analyzer": "^4.5.0"
  }
,
"build":"main-35343-v1.1.83"}
